/**
 * Take an html element containing tiling placeholders and expand
 * them into flow field components
 */

import { createApp, h, reactive } from 'vue';
import I18NextVue from 'i18next-vue';
import { getActivePinia } from 'pinia';
import i18next from '../lib/i18next';
import TEITilingFlowField from '@/components/teis/TEITilingFlowField.vue';

// This file is used by all Tiling flow TEIs, so these placeholders
// are keyed by component id
const expandedPlaceholders = {};

export default {
  beforeMount(el, binding) {
    const placeholderDivs = el.querySelectorAll('.tei-answerfield-holder');
    expandedPlaceholders[binding.value.componentId] = [];

    placeholderDivs.forEach((div, idx) => {
      const props = reactive({
        column: binding.value.columns[idx],
        interactive: binding.value.interactive,
        onChange: binding.value.onChange,
        onEnd: binding.value.onDragEnd,
        onRemoveTerm: binding.value.removeTerm,
        onStart: binding.value.onDragStart,
        onArrowKey: binding.value.onSelectedKeyboardTermKeydown,
      });

      const app = createApp({
        render: () => h(TEITilingFlowField, props),
      });

      app.use(I18NextVue, { i18next });
      app.use(getActivePinia());
      app.mount(div);

      expandedPlaceholders[binding.value.componentId].push({ app, props });
    });
  },
  updated(el, binding) {
    /* eslint-disable no-param-reassign */
    expandedPlaceholders[binding.value.componentId].forEach((expandedPlaceholder, idx) => {
      expandedPlaceholder.props.column = binding.value.columns[idx];
      expandedPlaceholder.props.interactive = binding.value.interactive;
    });
    /* eslint-enable no-param-reassign */
  },
  unmounted(el, binding) {
    expandedPlaceholders[binding.value.componentId].forEach(({ app }) => {
      app.unmount();
    });

    delete expandedPlaceholders[binding.value.componentId];
  },
};
